export default "__VITE_ASSET__CrmUWGvE__"